import React from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import {
  shape,
  string,
  func,
  bool,
  arrayOf,
  oneOf,
  objectOf
} from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import { lowerCase, map, isEmpty } from 'lodash';

import {
  fetchAppPackageComponentsByType,
  getFetchedComponentsOfType,
  isFetchingComponentsOfType,
  getExistingComponentsOfType
} from 'modules/application';
import { appPackageComponentTypes } from 'modules/application/constants';
import { required } from 'helpers/validate';
import { renderSelectField } from './customFields';

@connect(
  (state, { applicationId, componentType }) => ({
    isFetchingComponentsOfType: isFetchingComponentsOfType(state),
    componentsListByType: getFetchedComponentsOfType(state, componentType),
    componentsToExclude: getExistingComponentsOfType(
      state,
      applicationId,
      componentType
    )
  }),
  {
    fetchAppPackageComponentsByType
  }
)
export default class ComponentByIdField extends React.Component {
  static propTypes = {
    componentType: oneOf(map(appPackageComponentTypes, 'type')).isRequired,
    componentLabel: string.isRequired,
    fetchAppPackageComponentsByType: func.isRequired,
    isFetchingComponentsOfType: bool.isRequired,
    componentsListByType: arrayOf(
      shape({
        id: string.isRequired,
        name: string
      })
    ),
    componentsToExclude: objectOf(string)
  };

  static defaultProps = {
    componentsToExclude: {}
  };

  componentDidMount() {
    const { componentType } = this.props;

    if (componentType) {
      this.props.fetchAppPackageComponentsByType(componentType);
    }
  }

  render() {
    return (
      <Field
        name={this.props.componentType}
        component={renderSelectField}
        validate={[required]}
        label={`Select ${this.props.componentLabel}`}
      >
        {this.props.isFetchingComponentsOfType
          ? <MenuItem value="">Loading...</MenuItem>
          : isEmpty(this.props.componentsListByType)
            ? <MenuItem value="">
                There are no {lowerCase(this.props.componentLabel)}s to add
              </MenuItem>
            : this.props.componentsListByType.map(component =>
                <MenuItem
                  key={component.id}
                  value={component.id}
                  disabled={!!this.props.componentsToExclude[component.id]}
                >
                  {component.name}
                </MenuItem>
              )}
      </Field>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/applications/components/packageFormFields/ComponentByIdField.js